import React from "react";

const InvestmentTable = ({ investment, sumInvestments, square }) => {
  return (
    <div className="table-container">
      <table className="table" id="invest">
        <caption className="table-caption">
          Расчет вложений для площади {square} м²
        </caption>
        <thead>
          <tr>
            <th>Статья расходов</th>
            <th>Сумма (руб)</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(investment).map(([key, [value, name]]) => (
            <tr key={key}>
              <td className="table-fields__name">{name}</td>
              <td className="cell" style={{ textAlign: "right" }}>
                {Math.round(value).toLocaleString("ru-RU")}
              </td>
            </tr>
          ))}
          <tr style={{ fontWeight: "bold" }}>
            <td className="table-fields__name">ИТОГО:</td>
            <td className="cell" style={{ textAlign: "right" }}>
              {Math.round(sumInvestments).toLocaleString("ru-RU")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InvestmentTable;
